<template>
  <div class="nav_bar" :class="{ removeclass: !$props.selectValue }">
    <!-- <el-button type="primary" size="default" @click="isCollapse=true" /> -->
    <div class="logo" :class="{ centercss: !$props.selectValue }">
      <div class="logo_img" :class="{ mrcss: !$props.selectValue }">
        <img src="../../assets//img/logo.png" class="img" />
      </div>
      <div v-if="$props.selectValue" class="logo_text">
        <div>贝堡</div>
        <div style="font-size: 12px">DERNBURG</div>
      </div>
    </div>
    <div class="nav_box">
      <router-link
        v-for="item in navlist"
        :key="item.id"
        :to="'/' + item.link"
        class="linkbox"
        :class="{
          centercss: !$props.selectValue,
          linkboxative:
            (isLink === item.link && $props.selectValue) ||
            (isLink === '/' && item.id == 1 && $props.selectValue) ||
            (isLink === 'courseinfo' && item.id == 2 && $props.selectValue) ||
            (isLink === 'course' && item.id == 2 && $props.selectValue) ||
            (isLink === 'stucourse' && item.id == 2 && $props.selectValue) ||
            (isLink === '' && item.id === 1 && $props.selectValue) ||
            (isLink === 'attendclass' && item.id == 2 && $props.selectValue),
        }"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.name"
          placement="right"
        >
          <div class="linkboxicons" :class="{ mrcss: !$props.selectValue }">
            <svg-icon
              class="icon"
              :class="{
                icons:
                  isLink === item.link ||
                  (isLink === '/' && item.id == 1) ||
                  (isLink === 'courseinfo' && item.id == 2) ||
                  (isLink === '' && item.id === 1) ||
                  (isLink === 'course' && item.id == 2 && $props.selectValue) ||
                  (isLink === 'stucourse' &&
                    item.id == 2 &&
                    $props.selectValue) ||
                  (isLink === 'attendclass' && item.id === 2),
              }"
              :icon-class="item.icon"
            />
          </div>
        </el-tooltip>
        <div v-if="$props.selectValue" class="linkboxtext">{{ item.name }}</div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { getuser } from '../../api/login'
export default {
  // 组件名称
  name: 'NavBar',
  components: {},
  props: {
    selectValue: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      navlist: [],
      navlistt: [
        { id: 1, name: '首页', link: '', icon: 'Home' },
        { id: 2, name: '我的课程', link: 'course', icon: 'lkc' },
        { id: 3, name: '全部作业', link: 'jobpage', icon: 'teaas' },
        { id: 4, name: '考试', link: 'examinationpage', icon: 'lks' },
        // { id: 5, name: '资源管理', link: 'resource', icon: 'lzy' },
        { id: 6, name: '教材中心', link: 'textbook', icon: 'jc' },
      ],
      navlists: [
        // { id: 1, name: '首页', link: '', icon: 'Home' },
        { id: 2, name: '我的课程', link: '', icon: 'lkc' },
        { id: 3, name: '我的作业', link: 'jobpage', icon: 'teaas' },
        { id: 7, name: '公告', link: 'announcement', icon: 'stgg' },
        // { id: 8, name: '活动中心', link: 'activity', icon: 'sthd' },
        { id: 9, name: '考试中心', link: 'examination', icon: 'stks' },
        { id: 10, name: '教材中心', link: 'textbook', icon: 'jc' },
      ],
      link:
        this.$route.fullPath.split('/').length > 1
          ? this.$route.fullPath.split('/')[1]
          : this.$route.fullPath.split('/')[0] || 'index',
      isCollapse: false,
      userIsteacher: '', // 1 老师 0 学生
    }
  },
  computed: {
    isLink() {
      return this.$route.path.split('/')[1]
    },
  },
  created() {
    this.userIsteacher = this.$store.state.classinfo.sysUser.userIsteacher
    this.isTeacher()
  },
  methods: {
    isTeacher() {
      if (this.userIsteacher == '1') {
        this.navlist = this.navlistt
      } else {
        this.navlist = this.navlists
      }
    },
  },
}
</script>

<style scoped lang="scss">
.centercss {
  justify-content: center;
}
.mrcss {
  margin: 0 !important;
}
.el-menu {
  border-right: none;
}
.nav_bar {
  min-width: 250px;
  padding: 12px;
  border-right: 1px solid var(--gray_2);
  box-sizing: border-box;
  min-height: 100vh;
  background-color: white;
  transition: min-width 0.25s;
  .logo {
    height: 50px;
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    .logo_img {
      width: 50px;
      height: 50px;
      border-radius: 10px;
      margin-right: 25px;
      .img {
        width: 100%;
        // height: 100%;
      }
    }
    .logo_text {
      font-size: 34px;
      font-weight: 600;
      color: var(--textblack);
    }
  }
  .nav_box {
    width: 100%;
    .linkbox {
      width: 100%;
      height: 53px;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: var(--gray);
      .linkboxicons {
        width: 24px;
        height: 24px;
        margin-right: 17px;
        margin-left: 7px;
        .icons {
          width: 100%;
          color: #3f8cff;
          height: 100%;
        }
        .icon {
          width: 100%;
          height: 100%;
        }
      }
      .linkboxtext {
        font-size: 14px;
      }
    }
    .linkboxative {
      background-color: var(--gray_3);
      border-radius: 7px;
      color: var(--primary);
      position: relative;
    }
    .linkboxative::after {
      content: '';
      width: 4px;
      height: 52px;
      background-color: var(--primary);
      border-radius: 2px;
      position: absolute;
      right: -12px;
    }
  }
}
.removeclass {
  min-width: 90px !important;
  width: 90px !important;
  padding: 18px;
}
</style>
